// libs
import * as React from 'react'

// interfaces / constants

// classes / components
import Notification, { clsHighlightedText, clsText, NotificationProps } from 'src/components/notifications/notification'

// helpers
import { textResources } from 'src/lang/de'
import DateFormatter from 'src/utils/date_formatter/date_formatter'

// images
import { NotificationsQuery } from '@lopo-tech/lopo-api'
import * as overlayInactive from 'src/components/notifications/badges/following@2x.png'
import * as overlayActive from 'src/components/notifications/badges/following_active@2x.png'

const labels = textResources.notification

type Notification = NotificationsQuery['notifications']['items'][number];
type NotificationContentItemType = Extract<
  Notification['resourceLink'],
  { __typename?: 'ContentItemResourceLink' }
>['contentItem']['__typename'];

export type FollowNotificationProps = {
  contentItemTitle: string | null | undefined;
  contentItemType: NotificationContentItemType
  createdAt: string;
} & Pick<NotificationProps, 'avatarImage' | 'initiatorName' | 'isRead' | 'onClick'>

const FolloweePostNotification: React.FC<FollowNotificationProps> = ({
  avatarImage,
  createdAt,
  initiatorName,
  isRead,
  onClick,
  contentItemTitle,
  contentItemType
}) => {
  return (
    <Notification
      avatarImage={avatarImage}
      badgeImageNotRead={overlayActive}
      badgeImageRead={overlayInactive}
      footer={DateFormatter.asTimeAgo(createdAt)}
      initiatorName={initiatorName}
      isRead={isRead}
      onClick={onClick}
    >
      <span className={clsText}>{deriveBodyText(contentItemType, contentItemTitle)}</span>
      {contentItemTitle && <strong className={clsHighlightedText}>{`„${contentItemTitle}“`}</strong>}
    </Notification>
  )
}

export default FolloweePostNotification

const deriveBodyText = (contentItemType: NotificationContentItemType, contentItemTitle:string | null | undefined): string => {
  let translation

  if (contentItemType === 'Event') {
    translation = labels.followeeEvent(!!contentItemTitle)
  } else {
    translation = labels.followeePost(!!contentItemTitle)
  }

  // needs empty space between initiatorName and this text
  return ` ${translation}`
}
